/**
 * Page Context Hook
 * Provides page-specific context to global AI assistant
 */

import { useEffect, useMemo } from 'react';
import { useAI, PageContext } from '../contexts/AIContext';

export function usePageContext(context: PageContext) {
  const { setPageContext } = useAI();

  // Serialize context objects to stable strings for dependency comparison
  const documentContextStr = useMemo(() => JSON.stringify(context.documentContext), [context.documentContext]);
  const pageDataStr = useMemo(() => JSON.stringify(context.pageData), [context.pageData]);

  useEffect(() => {
    setPageContext(context);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- context object identity changes, we use serialized values for comparison
  }, [context.pageName, context.canEdit, documentContextStr, pageDataStr, setPageContext]);
}

